import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { DefaultComplianceSettingsCreateActivity } from '../../activities/defaultComplianceSettings/defaultComplianceSettingsCreate'
import { DefaultComplianceSettingsDeleteActivity } from '../../activities/defaultComplianceSettings/defaultComplianceSettingsDelete'
import { DefaultComplianceSettingsUpdateActivity } from '../../activities/defaultComplianceSettings/defaultComplianceSettingsUpdate'
import { FinanceContactCreateActivity } from '../../activities/financeContactCreate'
import { SalesDocumentTemplateCreateActivity } from '../../activities/salesDocumentTemplate/salesDocumentTemplateCreate'
import { SalesDocumentTemplateDeleteActivity } from '../../activities/salesDocumentTemplate/salesDocumentTemplateDelete'
import { SalesDocumentTemplateUpdateActivity } from '../../activities/salesDocumentTemplate/salesDocumentTemplateUpdate'
import { SerialSequenceCreateActivity } from '../../activities/serialSequenceCreate'
import { SerialSequenceDeleteActivity } from '../../activities/serialSequenceDelete'
import { SerialSequenceUpdateNameActivity } from '../../activities/serialSequenceUpdateName'
import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {
    salesDocumentTemplateCreate: {
      component: SalesDocumentTemplateCreateActivity,
    },
    salesDocumentTemplateDelete: {
      component: SalesDocumentTemplateDeleteActivity,
    },
    salesDocumentTemplateUpdate: {
      component: SalesDocumentTemplateUpdateActivity,
    },
    serialSequenceCreate: {
      component: SerialSequenceCreateActivity,
    },
    serialSequenceUpdateName: {
      component: SerialSequenceUpdateNameActivity,
    },
    serialSequenceDelete: {
      component: SerialSequenceDeleteActivity,
    },
    contactCreate: {
      component: FinanceContactCreateActivity,
    },
    defaultComplianceSettingsCreate: {
      component: DefaultComplianceSettingsCreateActivity,
    },
    defaultComplianceSettingsUpdate: {
      component: DefaultComplianceSettingsUpdateActivity,
    },
    defaultComplianceSettingsDelete: {
      component: DefaultComplianceSettingsDeleteActivity,
    },
  },
} as const satisfies DomainManifest
